// extracted by mini-css-extract-plugin
module.exports = {"related-content-new-wrapper":"_2nKRH","relatedContentNewWrapper":"_2nKRH","title":"A4Hy_"};